import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Widget from './pages/Widget';
import Landing from './pages/Landing';
import { LaunchParamsProvider } from './state/launchParams';
import './index.css';

// /widget is the one published URL; no redirects, a redirect would drop ?orgId.
function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/bloomreach">
        <LaunchParamsProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/widget" element={<Widget />} />
          <Route path="/health" element={<h2>Bloomreach UI up and running</h2>} />
        </Routes>
        </LaunchParamsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
